{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Option Exercise",
  "description": "Exercise an option grant",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "company": { "$ref": "#/definitions/company" },
    "option_exercise": {
      "$ref": "#/definitions/option_exercise"
    },
    "stakeholder": { "$ref": "#/definitions/stakeholder" }
  },
  "additionalProperties": false
}
